export default "<p>Please wait.....</p>";